import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SendToFinanceModalUI from './SendToFinanceModalUI'

class SendToFinanceModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
      successMsg: null,
      errorList: []
    }
  }

  onConfirmClick = () => {
    if (this.state.submitting) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitting: true
    })

    const loanId = this.props.loan.loanId

    RestApiUtils.post(
      this.props.context,
      `/api/disbursement-checklist/${loanId}/send-to-finance`,
      this.onSubmitCallback,
      null,
      null
    )
  }

  onSubmitCallback = (response) => {
    const errorList = []

    if (response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(error => {
        errorList.push(error.message || error)
      })
    }

    this.setState({
      successMsg: response.success || response.message || 'Successfully sent to Finance team',
      errorList: errorList,
      submitting: false
    })

    if (errorList.length === 0 && (response.success || response.checklist)) {
      setTimeout(() => {
        if (this.props.onSuccess) {
          this.props.onSuccess()
        } else {
          this.props.onCancelClick()
        }
      }, 1500)
    }
  }

  render() {
    return (
      <SendToFinanceModalUI
        loan={this.props.loan}
        onConfirmClick={this.onConfirmClick}
        onCancelClick={this.props.onCancelClick}
        submitting={this.state.submitting}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
      />
    )
  }
}

export default SendToFinanceModalSF